import dayjs from 'dayjs';

import { WorkOrderData } from '../../../api/workOrders/types';
import { PeriodKey } from '../constants';
import {
  DateRange,
  last12Months,
  periodRange,
  previousRange,
} from './dateRanges';

export interface BigWindow {
  range: DateRange;
  current: DateRange;
  previous: DateRange;
  last12m: DateRange;
}

const minDate = (...d: string[]): string =>
  d.reduce((acc, x) => (x < acc ? x : acc));

const maxDate = (...d: string[]): string =>
  d.reduce((acc, x) => (x > acc ? x : acc));

export const computeBigWindow = (period: PeriodKey): BigWindow => {
  const current = periodRange(period);
  const previous = previousRange(period);
  const twelve = last12Months();
  return {
    range: {
      start: minDate(current.start, previous.start, twelve.start),
      end: maxDate(current.end, previous.end, twelve.end),
    },
    current,
    previous,
    last12m: twelve,
  };
};

const inRange = (date: string | undefined, range: DateRange): boolean => {
  if (!date) return false;
  const d = dayjs(date);
  return (
    !d.isBefore(dayjs(range.start), 'day') &&
    !d.isAfter(dayjs(range.end), 'day')
  );
};

export const filterByCreatedAt = (
  rows: WorkOrderData[],
  range: DateRange
): WorkOrderData[] => rows.filter((r) => inRange(r.created_at, range));
